module.exports = __webpack_public_path__ + "img/d62e78f73207835574452d4519ca5a10.png";